import { render } from "./Orders.vue?vue&type=template&id=00e3c32e"
import script from "./Orders.vue?vue&type=script&lang=ts"
export * from "./Orders.vue?vue&type=script&lang=ts"
script.render = render

export default script